import { Context } from "@nuxt/types";

export default async function (ctx: Context) {
    ctx.store.commit('setBreadcrumbs', []);
}